function Block({ className }: { className?: string }) {
  return <div className={`skeleton-shimmer rounded-xl ${className ?? ""}`} />;
}

export function AnalyticsSkeleton() {
  return (
    <div className="space-y-8">
      <div className="space-y-3">
        <Block className="h-4 w-36" />
        <Block className="h-8 w-56" />
        <Block className="h-4 w-80 max-w-full" />
      </div>
      <QuickActionsSkeleton />
      <TopKpiSkeleton />
      <div className="grid gap-8 xl:grid-cols-12">
        <div className="xl:col-span-7">
          <ColumnSkeleton />
        </div>
        <div className="xl:col-span-5">
          <ColumnSkeleton compact />
        </div>
        <div className="xl:col-span-12">
          <ColumnSkeleton tall />
        </div>
      </div>
    </div>
  );
}

export function FeatureGridSkeleton() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6">
      {Array.from({ length: 6 }).map((_, i) => (
        <Block key={i} className="h-32" />
      ))}
    </div>
  );
}

export function FeedSkeleton() {
  return <Block className="h-72 w-full" />;
}

export function QuickActionsSkeleton() {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Block className="h-[72px]" />
      <Block className="h-[72px]" />
      <Block className="h-[72px]" />
    </div>
  );
}

export function TopKpiSkeleton() {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <Block className="h-28" />
      <Block className="h-28" />
      <Block className="h-28" />
      <Block className="h-28" />
    </div>
  );
}

export function ColumnSkeleton({
  compact = false,
  tall = false,
}: {
  compact?: boolean;
  tall?: boolean;
}) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Block className="h-3 w-16" />
        <Block className="h-6 w-40" />
        <Block className="h-4 w-64 max-w-full" />
      </div>
      {!compact ? (
        <div className="grid gap-3 sm:grid-cols-3">
          <Block className="h-20" />
          <Block className="h-20" />
          <Block className="h-20" />
        </div>
      ) : (
        <div className="grid gap-3">
          <Block className="h-20" />
          <Block className="h-20" />
        </div>
      )}
      <Block className={tall ? "h-80" : compact ? "h-48" : "h-56"} />
      {!compact && !tall ? <Block className="h-52" /> : null}
      {tall ? <Block className="h-64" /> : null}
    </div>
  );
}

export function RecentStripSkeleton() {
  return null;
}

export function ExplorerSkeleton({ title }: { title: string }) {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <Block className="h-4 w-36" />
        <Block className="h-8 w-48" />
        <p className="text-sm font-semibold text-muted">{title}</p>
        <Block className="h-4 w-72 max-w-full" />
      </div>
      <Block className="h-[420px] w-full" />
    </div>
  );
}

/** @deprecated Use AnalyticsSkeleton */
export function PageSkeleton() {
  return <AnalyticsSkeleton />;
}
